import { useSearchParams } from 'react-router-dom';
import EvalDatasets from './EvalDatasets';
import EvalRuns from './EvalRuns';
import ScenarioEvals from '../scenario-evals/ScenarioEvals';
import { AssignmentsTab } from './assignments/AssignmentsTab';
import { ExtractionTab } from './extraction/ExtractionTab';
import './Evals.css';

const TABS = ['scenarios', 'assignments', 'extraction', 'datasets', 'runs', 'performance'] as const;
type EvalsTab = typeof TABS[number];

/** The tab lives in the URL so a dataset page can link back to the tab it came from. */
function readTab(v: string | null): EvalsTab {
  return (TABS as readonly string[]).includes(v ?? '') ? (v as EvalsTab) : 'scenarios';
}

export default function Evals() {
  const [params, setParams] = useSearchParams();
  const tab = readTab(params.get('tab'));
  const setTab = (next: EvalsTab) => setParams({ tab: next }, { replace: true });

  return (
    <div className="evals-page">
      <h1>Evals</h1>

      <div className="evals-tabs">
        <button className={`evals-tab ${tab === 'scenarios' ? 'active' : ''}`} onClick={() => setTab('scenarios')}>Scenario Evals</button>
        <button className={`evals-tab ${tab === 'assignments' ? 'active' : ''}`} onClick={() => setTab('assignments')}>Assignments</button>
        <button className={`evals-tab ${tab === 'extraction' ? 'active' : ''}`} onClick={() => setTab('extraction')}>Extraction</button>
        <button className={`evals-tab ${tab === 'datasets' ? 'active' : ''}`} onClick={() => setTab('datasets')}>Datasets</button>
        <button className={`evals-tab ${tab === 'runs' ? 'active' : ''}`} onClick={() => setTab('runs')}>Eval Runs</button>
        <button className={`evals-tab ${tab === 'performance' ? 'active' : ''}`} onClick={() => setTab('performance')}>Performance Analysis</button>
      </div>

      {tab === 'scenarios' && <ScenarioEvals />}
      {tab === 'assignments' && <AssignmentsTab />}
      {tab === 'extraction' && <ExtractionTab />}
      {tab === 'datasets' && <EvalDatasets />}
      {tab === 'runs' && <EvalRuns forceTab="runs" />}
      {tab === 'performance' && <EvalRuns forceTab="performance" />}
    </div>
  );
}
